const securityLookUpColumns = (onSymbolClick: Function, symbolDirectory: any) => {
  return Object.keys(symbolDirectory[0]).map((key: any) => {
    return {
      Header: key,
      width: "150",
      accessor: (data : any) => data?.[key]?.trim() || '-',
    }
  })
}

export default securityLookUpColumns
